import { useSelector } from "react-redux";
import { selectShipment } from "../shipmentSlice";
import SendETGBBillDocument from "./SendETGBBillDocument";
import { useTranslation } from "react-i18next";
import { useMemo } from "react";
import Invoice from "./Invoice";
import {
    isB2BPackage,
    isC2CPackage,
    isStandardOrB2BOrC2CPackage,
    isStandardPackage,
} from "../../../helpers/packageTypesHelper/packageTypesHelper";
import C2CFileUpload from "./C2CFileUpload";

const checkIfCanBeShowed = (shipment) => {
    if (!shipment) return false;
    let canBeShowed = false;

    let packageType = shipment["package-type"];

    if (isB2BPackage(packageType) && shipment["B2B-order-type"] === "ETGB") {
        canBeShowed = true;
    }

    let isSupportedForInvoicePackageType =
        isStandardOrB2BOrC2CPackage(packageType);
    if (isSupportedForInvoicePackageType) {
        canBeShowed = true;
    }

    return canBeShowed;
};

const AdditionalFiles = () => {
    const { t } = useTranslation();
    const shipment = useSelector(selectShipment);

    const showed = useMemo(() => {
        return checkIfCanBeShowed(shipment);
    }, [shipment]);

    return (
        <>
            {showed && (
                <div className="flex flex-col gap-y-4 mb-10">
                    <header className="text-xl text-center text-emerald-600 font-bold mb-2">
                        {t("shipment.additional_files.title")}
                    </header>
                    {isB2BPackage(shipment["package-type"]) &&
                        shipment["B2B-order-type"] === "ETGB" && (
                            <>
                                <SendETGBBillDocument
                                    shipmentID={shipment.id}
                                    fileName={shipment["etgb-file-name"]}
                                />
                                <hr />
                            </>
                        )}
                    {(isStandardPackage(shipment["package-type"]) ||
                        isB2BPackage(shipment["package-type"])) && (
                        <>
                            <Invoice
                                shipmentID={shipment.id}
                                fileName={shipment["own-invoice-file-name"]}
                                isPonyExpressInvoice={
                                    shipment["is-pony-express-invoice"]
                                }
                            />
                            <hr />
                        </>
                    )}
                    {isC2CPackage(shipment["package-type"]) && (
                        <C2CFileUpload
                            shipmentID={shipment.id}
                            fileName={shipment["c2c-file-name"]}
                        />
                    )}
                    <hr />
                </div>
            )}
        </>
    );
};

export default AdditionalFiles;
